import { render, staticRenderFns } from "./TransitionProperty.vue?vue&type=template&id=31e1e23e&scoped=true&"
import script from "./TransitionProperty.vue?vue&type=script&lang=js&"
export * from "./TransitionProperty.vue?vue&type=script&lang=js&"
import style0 from "./TransitionProperty.vue?vue&type=style&index=0&id=31e1e23e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e1e23e",
  null
  
)

export default component.exports